import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up",
  "use": "icon-up-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-up\">\n<rect x=\"5.68555\" y=\"13.3438\" width=\"8\" height=\"1\" transform=\"rotate(-45 5.68555 13.3438)\" fill=\"#737373\" />\n<rect x=\"16.293\" y=\"14.0508\" width=\"8\" height=\"1\" transform=\"rotate(-135 16.293 14.0508)\" fill=\"#737373\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol